
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getOperDetails, updataOperAppConfig } from "@/api/api-basic";

import i18n from "@/config/i18n";
// import { getOptionList, optionKey } from "@/api/api-dict";

@Component({})
export default class AddOperPhoneModel extends Vue {
  private modalShow = false;
  private modalTitle = i18n.t("oper.phoneConfig");
  private loading = false;
  initForm = {
    muzzleLimit: "",
    checkoutType: 1,
    payChannel:11,
    payChannelMethod:[],
    hasCreditpayment: 0,
    plugAndCharge:0,
    hasInvoice: 0,
    hasCar: 0,
    hasChargingStrategy: 0,
    userNotificationMethod: 0,
    operatorNotificationMethod: [],
    operatorSmsNotificationMethod: 1,
    operatorEmailNotificationMethod: 0,
    operatorPasswordVerification: 0,
    notificationMethod: [],
    smsNotificationMethod: 1,
    emailNotificationMethod: 0,
    passwordSettingSkip: 0,
    passwordLogin: [],
    phonePasswordLogin: 1,
    emailPasswordLogin: 0,
    defaultLoginMethod: 0
  };
  private form = { ...this.initForm };
  private ruleInline: objAny = {
    operatorNotificationMethod: [{
      required: true, trigger: "change", validator: (rule: objAny, value: any, callback: any) {
        if (!value.length) {
          callback(new Error(i18n.t("pleaseSelect") + ""));
        } else {
          callback();
        }
      }
    }],
    notificationMethod: [{
      required: true, trigger: "change", validator: (rule: objAny, value: any, callback: any) {
        if (!value.length) {
          callback(new Error(i18n.t("pleaseSelect") + ""));
        } else {
          callback();
        }
      }
    }],
    passwordLogin: [{
      required: true, trigger: "change", validator: (rule: objAny, value: any, callback: any) {
        console.log(value)
        if (!value.length) {
          callback(new Error(i18n.t("pleaseSelect") + ""));
        } else {
          callback();
        }
      }
    }]
  }

  private tableColumns: object[] = [
    {
      title: i18n.t("oper.paymentChannel"),
      key: "oprName",
      slot: "paymentChannel",
    },
    {
      title: i18n.t("oper.channelPartners"),
      key: "companyName",
      slot: "channelPartners",
    },
  ];
  private tableData: object[] = [
    {
      title: 'PromptPay',
      key: "promptpay",
      payChannel:12,
      payMethod:0
    },
    {
      title: 'Line Pay',
      key: "linepay",
      payChannel:12,
      payMethod:0
    },
    {
      title: 'Credit Card',
      key: "card",
      payChannel:12,
      payMethod:0
    },
  ];


  public open(item: objAny) {
    this.$refs.formInline?.resetFields()
    this.modalShow = true;
    this.form = { ...this.initForm };
    this.getOperDetails(item.oprPkId);
  }

  async getOperDetails(oprPkId: string): Promise<void> {
    const ret = await getOperDetails({ oprPkId: oprPkId });
    if (ret.status === this.$config.apiStatus) {
      const data = ret.data[0] || {};
      this.form = { ...this.initForm, ...data };
      this.form.operatorNotificationMethod = []
      this.form.notificationMethod = []
      this.form.passwordLogin = []
      if (data.operatorSmsNotificationMethod) {
        this.form.operatorNotificationMethod.push(1)
      }
      if (data.operatorEmailNotificationMethod) {
        this.form.operatorNotificationMethod.push(2)
      }
      if (data.smsNotificationMethod) {
        this.form.notificationMethod.push(1)
      }
      if (data.emailNotificationMethod) {
        this.form.notificationMethod.push(2)
      }
      if (data.phonePasswordLogin) {
        this.form.passwordLogin.push(1)
      }
      if (data.emailPasswordLogin) {
        this.form.passwordLogin.push(2)
      }
      if(data.checkoutType === 1 ){
        this.tableData.forEach(e=>{
          data.payChannelMethod?.forEach(item=>{
            if(item.payMethod===e.key){
              e.payMethod = 1;
              e.payChannel = item.payChannel;
            }
          })
        })
      }
    }
  }

  public closeModal(): void {
    this.modalShow = false;
  }

  public updateTableData (index, key, value) {
    console.log(index, key, value)
    this.tableData[index][key] = value;
  }

  async handleSubmit(): Promise<void> {
    this.$refs.formInline.validate(async (valid: boolean) => {
      if (valid) {
        this.form.operatorSmsNotificationMethod = this.form.operatorNotificationMethod.includes(1) ? 1 : 0
        this.form.operatorEmailNotificationMethod = this.form.operatorNotificationMethod.includes(2) ? 1 : 0
        this.form.smsNotificationMethod = this.form.notificationMethod.includes(1) ? 1 : 0
        this.form.emailNotificationMethod = this.form.notificationMethod.includes(2) ? 1 : 0
        this.form.phonePasswordLogin = this.form.passwordLogin.includes(1) ? 1 : 0
        this.form.emailPasswordLogin = this.form.passwordLogin.includes(2) ? 1 : 0
        if(this.form.checkoutType === 1 ){
          const filterList =   this.tableData.filter(item=>item.payMethod ==1)
          if(filterList.length){
            this.form.payChannelMethod = filterList.map(item=>{
              return {
                payChannel:item.payChannel,
                payMethod:item.key
              }
            })
          } else {
            return this.$Message.error(i18n.t("oper.paymentChannelPl"));
          }
        } else if(this.form.checkoutType === 2){
          if(!this.form.payChannel){
            return this.$Message.error(i18n.t("oper.channelPartnersPl"));
          }
        }
        this.loading = true;
        const ret = await updataOperAppConfig(this.form);
        if (ret.status === this.$config.apiStatus) {

          const item = ret.data[0] || {};
          this.$emit("success", item);
          this.modalShow = false;
        } else {
          this.modalShow = true;
        }
        this.loading = false;
      }
    });
  }
  // private paymentChannelList: objAny[] = [];
  // async getOptionList(): Promise<void> {
  //   const data = await getOptionList([optionKey.paymentChannel]);
  //   this.paymentChannelList = data[optionKey.paymentChannel].map(item => {
  //     return {
  //       itemKey: Number(item.itemKey),
  //       itemValue: item.itemValue
  //     };
  //   });
  // }
  // mounted() {
  //   this.getOptionList();
  // }
}
